var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('p',{staticClass:"error-message"},[_vm._v("抱歉，您访问的页面找不到。")])])])
}]

export { render, staticRenderFns }